import React from "react";
import {IRouteProps, IViewProps} from "../../../ts/manager/view/ViewInterface";

const Error403Partial = (props:IRouteProps|IViewProps) =>
{
    return <section className="content-block">
        <div className="container">
            <div className="row">

                <div className="col-12 text-center">
                    You do not have permission to view this page.
                </div>
            </div>
        </div>
    </section>
}

export default Error403Partial;